<ion-title style="text-align: center;">Edit Verse</ion-title>

<textarea style="outline: none;" rows="25" [(ngModel)] = "NewText" >

</textarea>
<ion-item>
  <div>
    <span [innerHTML]="editedVerse"></span>
  </div>
</ion-item>
<ion-button (click)="dismiss()">{{ 'Send' | translation }}</ion-button>
